<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7"> Dokumenty k podpisu </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="documentHeadersByRole"
        :items="document.items"
        :loading="document.loading"
        :options.sync="document.options"
        hide-default-footer
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.updatedAt="{ item }">
          <DateTime :single-line="false" :datetime="item.updatedAt" />
        </template>
        <template v-slot:item.expireAt="{ item }">
          <DateTime :single-line="false" :datetime="item.expireAt" />
        </template>
        <template v-slot:item.synced="{ item }">
          <YesNo :value="item.synced" />
        </template>
        <template v-slot:item.note="{ item }">
          <v-tooltip top color="primary" max-width="250">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" class="note-max" v-on="on">
                {{ item.note }}
              </span>
            </template>
            <span> {{ item.note }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle color="primary" dense group>
            <v-btn
              color="blue-grey"
              text
              @click.prevent="downloadDocument($event, value.id, item.id)"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { downloadFile } from '@/components/mixins/downloadFile'
import DateTime from '@/components/DateTime'
import YesNo from '../YesNo.vue'
export default {
  name: 'OrderSignatureDocuments',
  components: { YesNo, DateTime },
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      document: {
        headers: [
          {
            text: 'Změněno',
            value: 'updatedAt',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Typ',
            value: 'type.text',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Stav',
            value: 'status.text',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Důvod zamítnutí',
            value: 'note',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Platnost odkazu',
            value: 'expireAt',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Staženo z Obelisku',
            value: 'synced',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            align: 'right',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['updatedAt'],
          sortDesc: [true],
        },
        items: [],
        loading: false,
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    documentHeadersByRole() {
      return this.document.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    // Handles internal model changes.
    value() {
      this.loadDocuments()
    },
  },
  created() {
    this.loadDocuments()
  },
  methods: {
    ...mapActions({
      getOrderDocuments: 'order/getOrderDocuments',
    }),
    loadDocuments() {
      this.document.loading = true
      this.getOrderDocuments(this.value.id)
        .then((response) => {
          this.document.items = response.data
          this.cancel = null
        })
        .finally(() => {
          this.document.loading = false
        })
    },
    downloadDocument(event, orderId, id) {
      this.downloadFile(event, `order/${orderId}/signature/document/${id}`)
    },
  },
}
</script>

<style scoped>
.note-max {
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}
</style>
